export const CHART_BG_COLORS = [
    'rgba(54, 162, 235, 0.7)',   // Bleu
    'rgba(255, 99, 132, 0.7)',   // Rouge
    'rgba(75, 192, 192, 0.7)',   // Turquoise
    'rgba(255, 206, 86, 0.7)',   // Jaune
    'rgba(153, 102, 255, 0.7)',  // Violet
    'rgba(255, 159, 64, 0.7)',   // Orange
    'rgba(46, 204, 113, 0.7)',   // Vert
    'rgba(149, 165, 166, 0.7)',  // Gris
    'rgba(52, 73, 94, 0.7)',     // Bleu foncé
    'rgba(243, 156, 18, 0.7)',   // Jaune foncé
];

export const CHART_BORDER_COLORS = [
    'rgb(54, 162, 235)',   // Bleu
    'rgb(255, 99, 132)',   // Rouge
    'rgb(75, 192, 192)',   // Turquoise
    'rgb(255, 206, 86)',   // Jaune
    'rgb(153, 102, 255)',  // Violet
    'rgb(255, 159, 64)',   // Orange
    'rgb(46, 204, 113)',   // Vert
    'rgb(149, 165, 166)',  // Gris
    'rgb(52, 73, 94)',     // Bleu foncé
    'rgb(243, 156, 18)',   // Jaune foncé
];
